<template>
  <div class="container-sign-banner">
    <div class="container-texts">
      <p class="text">¡Regístrate ahora y adelanta un paso en la compra de tus entradas!</p>
      <b-button type="button"
                class="topaz signup"
                @click="openSignupPurchase"> {{ $t('topHeader.registrate') }} </b-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openSignupPurchase() {
      this.$root.$emit('openSignupPurchase')
    }
  }
}
</script>

<style lang="scss">
@import './sign-banner.sass';
</style>
